module.exports = __webpack_public_path__ + "1bce3fec23b3c8c83ecd2f6e5fa5fbb4.woff";